import { BaseHttpProvider } from "./base-http.provider"

import type { LanguageISO } from "./types/lang"

export class TeamPageProvider extends BaseHttpProvider {
  async getTeamPage(lang: LanguageISO) {
    const { data, staff, locations, reviews } = await this.execute({
      uri: "/team-page",
      query: {
        lang,
      },
    })

    return {
      // @ts-ignore
      data: {
        ...data,
        translations:
          data.translations?.map((i) => ({
            key: i.Key,
            template: i.Template,
          })) ?? [],
      },
      staff,
      locations,
      reviews,
    }
  }
}

interface Image {
  url: string
  width: string
  height: string
}

export interface ResponsiveImage {
  origin: Image
  desktop: Image
  tablet: Image
  mobile: Image
}

export interface Teammate {
  id: string | number
  name: string
  picture: ResponsiveImage | null
  view: ResponsiveImage | null
  animation: string | null
  priority: number
  placeholder: string | null
  is_captain: boolean
  position: string
}
